// CORE
// Este é um arquivo core do boilerplate e modificações neste arquivo serão bloqueadas via pré-hook de commit.
// Fazemos este bloqueio para manter a consistência do boilerplate e diminuir as chances de conflitos nos updates.
// Caso possível, procure uma alternativa ao uso deste arquivo.
// Se a alteração for realmente necessária ou for um update do boilerplate,
// realize o commit usando o comando 'git commit --no-verify'.

import Link from 'next/link';

import { colorTokens, brandColors } from '@/config/theme/colors';
import { inter } from '../fonts';

export const MuiButton = {
  styleOverrides: {
    defaultProps: {
      LinkComponent: Link,
    },
    root: {
      variants: [
        {
          props: { size: 'small' },
          style: { fontSize: '0.8rem' },
        },
        {
          props: { size: 'medium' },
          style: { fontSize: '1rem', padding: '6px 12px' },
        },
        {
          props: { size: 'large' },
          style: { fontSize: '1.2rem', padding: '6px 16px' },
        },
        {
          props: { variant: 'call-to-action' },
          style: {
            fontSize: '1.2rem',
            padding: '6px 16px',
            fontWeight: 800,
            textTransform: 'uppercase',
            backgroundColor: brandColors.primary.main,
            color: brandColors.primary.contrastText,
            '&:hover': {
              backgroundColor: brandColors.primary.buttonHover,
            },
          },
        },
        {
          props: { variant: 'call-to-action', color: 'secondary' },
          style: {
            backgroundColor: brandColors.secondary.main,
            color: brandColors.secondary.contrastText,
            '&:hover': {
              backgroundColor: brandColors.secondary.buttonHover,
            },
          },
        },
        {
          props: { variant: 'call-to-action', color: 'terciary' },
          style: {
            backgroundColor: brandColors.terciary.main,
            color: brandColors.terciary.contrastText,
            '&:hover': {
              backgroundColor: brandColors.terciary.buttonHover,
            },
          },
        },
      ],
      fontFamily: inter.style.fontFamily,
      textTransform: 'none',
      fontWeight: 600,
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      '&:active': {
        boxShadow: 'none',
      },
    },
    contained: {
      variants: [
        {
          props: { color: 'primary' },
          style: {
            '&:hover': {
              backgroundColor: brandColors.primary.buttonHover,
            },
          },
        },
        {
          props: { color: 'secondary' },
          style: {
            '&:hover': {
              backgroundColor: brandColors.secondary.buttonHover,
            },
          },
        },
        {
          props: { color: 'terciary' },
          style: {
            '&:hover': {
              backgroundColor: brandColors.terciary.buttonHover,
            },
          },
        },
      ],
      '&.Mui-disabled': {
        backgroundColor: colorTokens.button.disabled.background,
        color: colorTokens.button.disabled.text,
      },
    },
    outlined: {
      '&.Mui-disabled': {
        borderColor: colorTokens.button.disabled.background,
        color: colorTokens.button.disabled.text,
      },
    },
    text: {
      '&.Mui-disabled': {
        color: colorTokens.button.disabled.text,
      },
    },
  },
};
